// extracted by mini-css-extract-plugin
module.exports = {"root":"t_bY","filled":"t_b4","input-area":"t_b5","inputArea":"t_b5","label":"t_b6"};